//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 18.04.2016.
 */

(function () {

    'use strict';

    const SortDirection = {
        ASC: 'asc',
        DESC: 'desc'
    };

    const SortDataType = {
        CHECKBOX: 'boolean',
        DATE: 'date',
        DURATION: 'duration',
        FILE_SIZE: 'fileSize',
        IP_ADDRESS: 'ipAddress',
        TEXT: 'text',
        NUMBER: 'number'
    };

    angular.module('container.core')
        .factory('sortService', sortService)
        .constant('SortDirection', SortDirection)
        .constant('SortDataType', SortDataType);

    function sortService(MegaTableItemProperty) {

        let service = {};

        service.sortItemsByDate = (items, property, direction) => {

            return stableSort(items.slice(), (a, b) => {

                return (moment.utc(a[property]).valueOf() - moment.utc(b[property]).valueOf()) * (direction == SortDirection.ASC ? 1 : -1);
            });
        };

        service.sortItemsByDuration = (items, property, direction) => {

            return stableSort(items.slice(), (a, b) => {

                return (a[property] - b[property]) * (direction == SortDirection.ASC ? 1 : -1);
            });
        };

        service.sortItemsByFileSize = (items, property, direction) => {

            return stableSort(items.slice(), (a, b) => {

                return (parseInt(a[property], 10) - parseInt(b[property], 10)) * (direction == SortDirection.ASC ? 1 : -1);
            });
        };

        service.sortItemsByIpAddress = (items, property, direction) => {

            return stableSort(items.slice(), (a, b) => {

                let aOctets = getOctets(a[property]);
                let bOctets = getOctets(b[property]);
                let comp = 0;

                for (let i = 0; i < 4; i++) {
                    comp = aOctets[i] - bOctets[i];
                    if (comp != 0) break;
                }

                return comp * (direction ? 1 : -1);
            });

            function getOctets(ipAddress) {
                return ipAddress.split('.').map(octet => parseInt(octet, 10));
            }
        };

        service.sortItemsByGenericDataType = (items, property, direction) => {

            return stableSort(items.slice(), (a, b) => {

                a = a[property];
                if (a == null) a = false;
                b = b[property];
                if (b == null) b = false;

                let comp;

                if (a != b) {
                    if (a != b && (a == false || b == false))
                        comp = a == false ? 1 : -1; 
                    else if (a.localeCompare)
                        comp = a.localeCompare(b);
                    else if (a == b)
                        comp = 0;
                    else
                        comp = a < b ? -1 : 1;
                }

                return comp * (direction == SortDirection.ASC ? 1 : -1);
            });
        };

        service.sortItemsByNumber = (items, property, direction) => {

            return stableSort(items.slice(), (a, b) => {
                return (a[property] - b[property]) * (direction == SortDirection.ASC ? 1 : -1);
            });
        };

        service.sortItemsByBoolean = (items, property, direction) => {
            return stableSort(items.slice(), (MegaTableEntry1, MegaTableEntry2) => {
                let isSelected = MegaTableItemProperty.SELECTED;
                let MegaTableValue1 = MegaTableEntry1[isSelected] ? MegaTableEntry1[isSelected] : false;
                let MegaTableValue2 = MegaTableEntry2[isSelected] ? MegaTableEntry2[isSelected] : false;
                if (direction === "asc") {
                    return (MegaTableValue1 === MegaTableValue2) ? 0 : MegaTableValue1 ? -1 : 1;
                } else {
                    return (MegaTableValue1 === MegaTableValue2) ? 0 : MegaTableValue2 ? -1 : 1;
                }

            });
        };

        service.getSortFn = dataType => {

            switch (dataType) {
                case SortDataType.TEXT: default: return service.sortItemsByGenericDataType;
                case SortDataType.DATE: return service.sortItemsByDate;
                case SortDataType.DURATION: return service.sortItemsByDuration;
                case SortDataType.FILE_SIZE: return service.sortItemsByFileSize;
                case SortDataType.IP_ADDRESS: return service.sortItemsByIpAddress;
                case SortDataType.NUMBER: return service.sortItemsByNumber;
                case SortDataType.CHECKBOX: return service.sortItemsByBoolean;
            }
        };

        function stableSort(array, compare) {
            let array2 = array.map(function (currentValue, index) { return { index: index, value: currentValue } });
            array2.sort(function (a, b) {
                let compareResult = compare(a.value, b.value);
                return compareResult == 0 ? a.index - b.index : compareResult;
            });
            return array2.map(function (currentValue) { return currentValue.value });
        }

        return service;
    }
})();